module.exports = __webpack_public_path__ + "img/record-news-site.jpg";